export default "__VITE_ASSET__5afbf713__"